module.exports = __webpack_public_path__ + "38c63c3e8d940b35fc32fb62ade197c3.svg";